<script setup>

const route = useRoute()
const url = useRequestURL()

const { data: page } = await useAPIFetch(`Article/${route.params.slug}`)

if (!page.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
		fatal: true
  })
}

const relatedList = page.value.body.find(item => item.specific === 'RelatedList')

const album = page.value.body.find(item => item.specific === 'Album')

useHeadData({
	title: page.value.meta.title,
	description: page.value.meta.description,
	author: page.value.meta.author,
	copyright: page.value.meta.copyright,
	keywords: page.value.meta.keywords,
	og: page.value.meta.og,
	url: url.href
})

</script>

<template>
	<div class="container">
		<ArticleHeader class="mb-10 xl:mb-20" :title="page.attrs.title" :date="page.attrs.published" :type="page.type" />

		<div class="flex justify-center mb-10 xl:mb-20">
			<NuxtImg :class="[page.attrs.imageBody?.type === 'square' ? 'max-w-3xl' : '']" :src="page.attrs.imageBody.url" :width="page.attrs.imageBody.width || 'auto'" :height="page.attrs.imageBody.height || 'auto'" />
		</div>
		<div class="xl:grid grid-cols-12 gap-8 mb-10 xl:mb-20">
			<div class="col-span-8 col-start-3">
				<WysiwygPerex :value="page.attrs.perex" />
				
				<!-- article components loop -->
				<div v-for="component in page.body" :key="component.id">
					<div class="mb-12" v-if="component.component === 'Text'" ><WysiwygText  :value="component.content" /></div>
					<div class="mb-12" v-else-if="component.component ==='Video'"><Video :video="component.video" :start="component.start" /></div>
					<div class="gallery mb-12" v-else-if="component.component ==='Gallery'"><Swiper :items="component.items" /></div>
					<div class="mb-12" v-else-if="component.component ==='Track'"><Track color="green" :album="page.attrs.album.attrs" :tracklistUrl="`Article/${route.params.slug}/component/${component.id}`" /></div>
				</div>

				<!-- article album -->
				 <div v-if="album" class="mb-12">
					<AlbumLink :album="album.album" />
				 </div>
			</div>

			<!-- related -->
			<div v-if="relatedList" class="col-span-12 mt-8">
				<h2 class="text-red mb-10">{{ $t('generic.related-news') }}</h2>
				<Grid :covers="relatedList.items" :cursor="null" noPadding />
			</div>
			
		</div>
	</div>
</template>

<style lang="scss" scoped>
.gallery {
	position: relative;
	width: 100vw;
	left: 50%;
	transform: translateX(-50%);
}
</style>